export default function containsSpaces(value) {
    var DISALLOWED = /[ ]/;
    return DISALLOWED.test(value);
}
